<template>
    <el-form label-position="top"
        class="base">

        <!-- 标题 -->
        <el-form-item label="标题">
            <el-input placeholder="请输入..."
             maxlength="50"
             show-word-limit
             v-model="componentItem.chName">
            </el-input>
        </el-form-item>

        <!-- 提示信息 -->
        <el-form-item label="提示信息"
         v-if="componentItem.comment !== undefined
          && componentItem.comment !== null">
            <el-input placeholder="请输入..."
             maxlength="50"
             show-word-limit
             v-model="componentItem.comment">
            </el-input>
        </el-form-item>

        <!-- 性别 -->
        <span style="color: gray;font-size: 14px;"
         v-if="componentItem.name === 'sex'">选项默认为男/女</span>

        <!-- 地址 -->
        <el-form-item label="填写详细地址"
         v-if="componentItem.name === 'address'">
            <el-switch
             :active-value="1"
             :inactive-value="0"
             inactive-color="#ff4949"
             v-model="componentItem.isFullAddress">
            </el-switch>
        </el-form-item>
        <el-form-item label="所在医院地址"
         v-if="componentItem.name === 'address'">
            <el-switch
             :active-value="1"
             :inactive-value="0"
             inactive-color="#ff4949"
             v-model="componentItem.isHospitalAddress">
            </el-switch>
        </el-form-item>

        <!-- 选择题 -->
        <el-form-item label="类型"
         required
         v-if="componentItem.name === 'choice'">
            <el-radio
             v-model="componentItem.type" 
             :label="5">单选</el-radio>
            <el-radio
             v-model="componentItem.type"
             :label="6">多选</el-radio>
        </el-form-item>
        <!-- 选择题选项 -->
        <el-form-item label="选项"
         required
         v-if="componentItem.name === 'choice'">
            <div
             label-position="right"
             label-width="80px">
                <div
                 class="choice"
                 v-for="(item, index) in componentItem.contents"
                 :key="index">
                    <div class="label">
                        <span>*</span>
                        {{index | indexFilter}}
                    </div>
                    <el-input
                     v-model="item.content"
                     maxlength="100"
                     show-word-limit>
                        <el-button
                         slot="append"
                         icon="el-icon-delete"
                         @click="removeOption(index)"></el-button>
                    </el-input>
                </div>
                <div>
                    <el-button
                     type="primary"
                     size="small"
                     class="choiceBtn"
                     @click="addOptions">添加选项 +</el-button>
                </div>
            </div>
        </el-form-item>

        <!-- 限制字符 -->
        <el-form-item label="限制字符"
         v-if="componentItem.limitUser">
            <el-input placeholder="默认为50个字符"
             :maxlength="componentItem.limitUser"
             show-word-limit
             v-model="componentItem.limitLength"
             @blur="inputBlur('limitLength', 50)">
            </el-input>
        </el-form-item>
        
        <!-- 必填 -->
        <el-form-item label="必填">
            <el-switch
             :active-value="1"
             :inactive-value="0"
             inactive-color="#ff4949"
             v-model="componentItem.isRequired">
            </el-switch>
        </el-form-item>
    </el-form>
</template>

<script scoped>
    export default {
        data() {
            return {
            }
        },
        props: {
            componentItem: {
				type: Object,
				default: () => {}
			},
        },
        methods: {
            addOptions() {
                let length = this.componentItem.contents.length
                if(length > 25) {
                    this.$message.warning('不得超过26个选项')
                    return
                }
                this.componentItem.contents.push({
                    content: ''
                })
            },
            removeOption(index) {
                this.componentItem.contents.splice(index, 1)
            },
            inputBlur(key, val) {
                this.componentItem[key] = val
            }
        },
        filters: {
            indexFilter(index) {
                const key = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
                'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
                return key[index]
            }
        }
    }
</script>

<style type="text/less" lang="less" scoped>
.choice{
    display: flex;
    margin-bottom: 10px;
    .label{
        flex: none;
        width: 50px;
        span{
            color: #F56C6C;
        }
    }
}
.choiceBtn{
    margin-left: 50px;
}
</style>


// WEBPACK FOOTER //
// src/views/operateManage/signupform/components/rightComponents/items.vue